// extracted by mini-css-extract-plugin
module.exports = {"sign":"AffordableCarsShaqGraphic_sign__ynEdb"};